export default "__VITE_ASSET__YoSxAqgj__"